import React, { useState, useEffect } from "react";
import "./VendorList.css";
import { useLoader } from '../../../../context/LoaderProvider.jsx';
import { getVendorCreditTransactions } from "../../../Servicefile/AccountManagementService.jsx";
const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "10px",
};

const tableHeaderStyle = {
    padding: "10px",
    border: "1px solid #ddd",
    textAlign: "center",
    fontWeight: "bold",
    backgroundColor: "rgb(230 109 51)",
    color: "white",
};

const tableCellStyle = {
    padding: "10px",
    border: "1px solid #ddd",
    textAlign: "center",
    verticalAlign: "middle",
};

const filterButtonStyle = {
    backgroundColor: "rgb(230 109 51)",
    color: "white",
    border: "none",
    height: "35px",
    borderRadius: "4px",
    padding: "0 15px",
    cursor: "pointer",
};

const filterSelectStyle = {
    backgroundColor: "rgb(230 109 51)",
    color: "#fff",
    border: "none",
    height: "35px",
    borderRadius: "4px",
    padding: "0 10px",
};


// ✅ Helper: Format Date
const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
};

// ✅ Helper: Format Date + Time
const formatDateTime = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${day}-${month}-${year} ${hours}:${minutes}`;
};

// ✅ Helper: Status
const getStatus = (endDate) => {
    if (!endDate) return "Unknown";
    const today = new Date();
    const end = new Date(endDate);
    return end >= today ? "Active" : "Expired";
};

const VendorCreditspoints = () => {
    const [data, setData] = useState([]);
    const [selectedDate, setSelectedDate] = useState("");
    const [loading, setLoading] = useState(true);
    const { showLoader, hideLoader } = useLoader();
    // ✅ Fetch Data
    useEffect(() => {

        const today =
            new Date().toISOString().split("T")[0];

        setSelectedDate(today);

        const fetchTransactions = async () => {
            try {

                showLoader();

                const result =
                    await getVendorCreditTransactions(
                        today,
                        today
                    );

                setData(
                    Array.isArray(result)
                        ? result
                        : []
                );

            } catch (error) {

                console.error(
                    "Error fetching transactions:",
                    error
                );

            } finally {

                setLoading(false);
                hideLoader();
            }
        };

        fetchTransactions();

    }, []);
    useEffect(() => {

        if (!selectedDate) return;

        const fetchTransactions = async () => {
            try {

                showLoader();

                const result =
                    await getVendorCreditTransactions(
                        selectedDate,
                        selectedDate
                    );

                setData(
                    Array.isArray(result)
                        ? result
                        : []
                );

            } catch (error) {

                console.error(
                    "Error fetching transactions:",
                    error
                );

                setData([]);

            } finally {

                hideLoader();
            }
        };

        fetchTransactions();

    }, [selectedDate]);
    // ✅ Apply Date Filter
    const filteredData = data.filter((item) => {
        if (!selectedDate) return true;

        const orderDate = new Date(item.transactionDate);

        const filterDate = new Date(selectedDate);

        return (
            orderDate.getDate() === filterDate.getDate() &&
            orderDate.getMonth() === filterDate.getMonth() &&
            orderDate.getFullYear() === filterDate.getFullYear()
        );
    });

    // ✅ Export Function
    const handleExport = () => {

        if (filteredData.length === 0) {
            alert("No data to export.");
            return;
        }

        const headers = [
            "S.No",
            "Vendor ID",
            "Transaction Date",
            "Credit Amount",
            "Transaction Type",
            "Description",
            "Transaction ID"
        ];

        const csvRows = filteredData.map((item, index) => [
            index + 1,
            item.vendorId || "N/A",
            formatDateTime(item.transactionDate),
            item.creditAmount || 0,
            item.transactionType || "N/A",
            item.description || "N/A",
            item.transactionId || "N/A"
        ]);

        const csvContent = [
            headers.join(","),
            ...csvRows.map(row => row.join(","))
        ].join("\r\n");

        const blob = new Blob(
            [csvContent],
            {
                type: "text/csv;charset=utf-8;"
            }
        );

        const url =
            window.URL.createObjectURL(blob);

        const link =
            document.createElement("a");

        link.href = url;

        link.download =
            `Vendor_Credit_Transactions_${selectedDate}.csv`;

        document.body.appendChild(link);

        link.click();

        document.body.removeChild(link);

        window.URL.revokeObjectURL(url);
    };

    return (
        <div style={{ height: "100vh", overflowY: "auto", marginTop: '10px' }}>

            <div
                className="d-flex flex-wrap align-items-center mb-3 "
                style={{ gap: "10px" }}
            >
                <div>
                    <input
                        type="date"
                        value={selectedDate}
                        onChange={(e) => setSelectedDate(e.target.value)}
                        style={filterSelectStyle}
                    />
                </div>

                <div style={{ marginLeft: "auto" }}>
                    <button onClick={handleExport} style={filterButtonStyle}>
                        Export CSV
                    </button>
                </div>
            </div>

            {/* ✅ Table Foodand Beverages Community wich is not defined by the referal formated */}
            {loading ? (
                <p>Loading vendor data...</p>
            ) : (
                <div className="ooo">
                    <table style={tableStyle}>
                        <thead>
                            <tr>
                                <th style={tableHeaderStyle}>S.No</th>
                                <th style={tableHeaderStyle}>Vendor ID</th>
                                <th style={tableHeaderStyle}>Date</th>
                                <th style={tableHeaderStyle}>Credit Amount</th>
                                <th style={tableHeaderStyle}>Transaction Type</th>
                                <th style={tableHeaderStyle}>Description</th>

                                <th style={tableHeaderStyle}>Transaction ID</th>

                            </tr>
                        </thead>
                        <tbody>
                            {filteredData.length > 0 ? (
                                filteredData.map((entry, index) => (
                                    <tr key={entry.id}>
                                        <td style={tableCellStyle}>
                                            {index + 1}
                                        </td>

                                        <td style={tableCellStyle}>
                                            {entry.vendorId}
                                        </td>

                                        <td style={tableCellStyle}>
                                            {formatDate(entry.transactionDate)}
                                        </td>

                                        <td style={tableCellStyle}>
                                            ₹{entry.creditAmount}
                                        </td>

                                        <td style={tableCellStyle}>
                                            {entry.transactionType}
                                        </td>

                                        <td style={tableCellStyle}>
                                            {entry.description}
                                        </td>

                                        <td style={tableCellStyle}>
                                            {entry.transactionId}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="10" style={tableCellStyle}>
                                        No records found for selected date.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default VendorCreditspoints;
